export const prepCourses = [
    {course_id: 3276498, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 2196488, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 1921420, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 6082775, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 5668016, is_practice_test_course: 0, provider: 'COMPTIA'},
    {course_id: 2789348, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 4802926, is_practice_test_course: 0, provider: 'COMPTIA'},
    {course_id: 4223486, is_practice_test_course: 0, provider: 'COMPTIA'},
    {course_id: 5591620, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 3427676, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 2533568, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 5072786, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 2529790, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 6125705, is_practice_test_course: 0, provider: 'AWS'},
    {course_id: 2771884, is_practice_test_course: 0, provider: 'AWS'},
];

export const practiceCourses = [
    {course_id: 3142170, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 2597160, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 1975038, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 6093727, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 5652528, is_practice_test_course: 1, provider: 'COMPTIA'},
    {course_id: 3531972, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 5257056, is_practice_test_course: 1, provider: 'COMPTIA'},
    {course_id: 5787684, is_practice_test_course: 1, provider: 'COMPTIA'},
    {course_id: 5630800, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 3427682, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 2567118, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 5143410, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 2674140, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 6139021, is_practice_test_course: 1, provider: 'AWS'},
    {course_id: 4340056, is_practice_test_course: 1, provider: 'AWS'},
];
